import { Div } from '@expo/html-elements'
import { dsv } from '../../../styles/defaults'
import SelectList from '../../SelectList'
import { t } from 'i18next'
import { addPrefix } from '../../../locales/translationKeys'
import { useMemo } from 'react'

export type DataListAddFieldProps<TOptions extends string> = {
  height: number
  padding: number
  fieldOptions: Array<TOptions>
  addField: (option: TOptions) => void
}

export function DataListAddField<TOptions extends string>({
  height,
  padding,
  fieldOptions,
  addField,
}:DataListAddFieldProps<TOptions>){
  const data = useMemo(
    ()=>fieldOptions.map((field) => ({key:field, value: t(addPrefix('tableHeaders', field))})),
    [fieldOptions]
  )
  return (
    <Div style={{
      height: height,
      backgroundColor: dsv.colors.GpJouleGelb,
      justifyContent:"center",
      padding: padding,
      paddingLeft: 10, // TODO add this as a component prop
    }}>
      <SelectList

        disabled={false}
        data={data}
        setSelected={(option) => {
          if (option) addField(option)
        }}
        
        boxStyles={{
          minHeight: 36,
          width: 156, // TODO add this as a component prop
          backgroundColor: dsv.colors.connectGrau7,
          borderRadius: 0,
          borderStyle: 'solid',
          borderColor: dsv.colors.connectGrau30,
        }}
        disabledItemStyles={{}}
        disabledTextStyles={{}}
        placeholder="Feld Hinzufügen"
        notFoundText="Keine Weiteren Felder"
        
      />
    </Div>
  )
}